<div class="container-modal-sedes">
    <button class="close-modal" (click)="close()">×</button>

    <div class="title-container">
        <h1 class="quicksand-medium ">CONTACTANOS </h1>
        <img src="./assets/img/whatsapp-blanco2.png" alt="">
    </div>
    <span class="nunito-medium"> Escribinos al WhatsApp de tu sede de interés para que te podamos informar</span>
    <div class="buttons-sedes">
        <div class="button-sede" (click)="url(item)" *ngFor="let item of sedes">
            {{item.text}}
        </div>
    </div>
</div>